export default Object.freeze({
    debug: true,
    title: "ビルガント",
    actl:   "bill-gantts",
    aaction: "list",
    getBillsLists: "get-bills-lists",
    saveAdd: "save-add",
    edit: "edit-gantt",
    delete: "delete-gantt"
});